<label class="label">{{ label }}</label>
<ng-select class="select" [formControlName]="name" [items]="options" bindValue="value" bindLabel="label">
</ng-select>
